import React, { useState } from "react";
import Navigation from "./Navigation";
import Card from "./Card";
import { HelpCircle, ChevronDown, ChevronRight } from "lucide-react";
import faqData, { resolveFaqAnswer } from "../data/faqData";
import useInstanceInfo from "../hooks/useInstanceInfo";

const FAQ = () => {
  const [openItems, setOpenItems] = useState({});
  const { info } = useInstanceInfo();

  const toggleItem = (key) => {
    setOpenItems(prev => ({ ...prev, [key]: !prev[key] }));
  };

  return (
    <div className="min-h-screen bg-theme-primary">
      <Navigation />
      <div className="max-w-4xl mx-auto px-4 py-8">
        <div className="flex items-center gap-3 mb-2">
          <HelpCircle className="h-8 w-8 text-accent-cyan" />
          <h1 className="text-2xl font-bold text-content-primary">Frequently Asked Questions</h1>
        </div>
        <p className="text-content-secondary mb-8 ml-11">
          Find answers to common questions about the Axaris platform.
        </p>

        <div className="space-y-6">
          {faqData.map((section, sectionIdx) => (
            <Card key={sectionIdx} variant="elevated">
              <h2 className="text-lg font-semibold text-content-primary mb-3">{section.category}</h2>
              <div className="divide-y divide-border">
                {section.questions.map((item, qIdx) => {
                  const key = `${sectionIdx}-${qIdx}`;
                  const isOpen = openItems[key];
                  return (
                    <div key={key}>
                      <button
                        onClick={() => toggleItem(key)}
                        className="flex items-center w-full text-left py-3 gap-2 text-content-primary hover:text-accent-cyan transition-colors"
                      >
                        {isOpen
                          ? <ChevronDown className="h-4 w-4 flex-shrink-0 text-accent-cyan" />
                          : <ChevronRight className="h-4 w-4 flex-shrink-0 text-content-secondary" />
                        }
                        <span className="font-medium text-sm">{item.q}</span>
                      </button>
                      {isOpen && (
                        <p className="text-sm text-content-secondary pb-3 pl-6 leading-relaxed">
                          {resolveFaqAnswer(item.a, info.supportEmail)}
                        </p>
                      )}
                    </div>
                  );
                })}
              </div>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FAQ;
